var _circle, _circle2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerifyEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#64CD82",
    fillOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.0014,
    cy: 24.0014,
    r: 17.4545,
    fill: "#64CD82",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.95 34L23.7 29.75L25.1 28.35L27.95 31.2L33.6 25.55L35 26.95L27.95 34ZM24 23L32 18H16L24 23ZM24 25L16 20V30H21.15L23.15 32H16C15.45 32 14.979 31.804 14.587 31.412C14.195 31.02 13.9993 30.5493 14 30V18C14 17.45 14.196 16.979 14.588 16.587C14.98 16.195 15.4507 15.9993 16 16H32C32.55 16 33.021 16.196 33.413 16.588C33.805 16.98 34.0007 17.4507 34 18V22.35L32 24.35V20L24 25Z",
    fill: "#64CD82"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyEmail);
export default __webpack_public_path__ + "static/media/verify-email.922598b3e0e231ebe83d09d8fd4763f1.svg";
export { ForwardRef as ReactComponent };